export function clean([cn]) {
  return cn.replace(/\n/gu, ' ').replace(/\s+/gu, ' ');
}
